<terra-dialog-header>
    <h1>One or More Entities Have Investments and Cannot Be Removed</h1>
</terra-dialog-header>


<mat-dialog-content class="main-contant">
    <div class="dialog-content-container">
        <div class="sub-title">
            <div>The following entities have at least one investment and cannot be deleted. </div>
            <div>Please remove it from the deals first if you wish to proceed.</div>
            <div>Entities:</div>
        </div>
        <div class="description">
            <ol class="bank-details-list">
                @for(entity of data; track $index;){
                <li [ngClass]="{'list-style': data.length > 1}">
                    <span class="font-bold">{{entity.investingEntityName}}</span>
                    <div class="investments-details ml-2" *ngFor="let type of INVESTMENT_TYPE_ORDER">
                        <span class="related-type">{{ type }}: </span>
                        @for(investmentDetails of getRelevantInvestmentType(entity.investmentsDetails, type); track
                        $index; let j = $index){
                        <a target="_blank"
                            [href]="getHoldinRoute(investmentDetails.holdingId, investmentDetails.holdingDiscriminator)"
                            routerLinkActive="router-link-active">{{ investmentDetails.holdingName }}</a>
                        }
                    </div>
                </li>
                }
            </ol>
        </div>
    </div>
</mat-dialog-content>

<div mat-dialog-actions class="actions">
    <button mat-flat-button color="primary" [mat-dialog-close]="false" type="button" aria-label="Close"
        class="cancel-button">
        Close
    </button>
</div>